class ProductHighlightCarousel extends SplideCarousel {
  constructor(section, splideOptions) {
    super(section, splideOptions)
    
    this.splideNav = this.section.querySelector('.js-product-highlight-splide-nav');
    this.navListeners();
  }

  navListeners() {
    this.splideNav.addEventListener('click', this.splideProductHightlightCarouselNavClick.bind(this))
  }

  removeSliderEventListeners() {
    this.splideNav.removeEventListener('click', this.splideProductHightlightCarouselNavClick);
  }

  splideProductHightlightCarouselNavClick(event) {
    // Add/remove active state for color swatches
    const activeElements = this.splideNav.querySelectorAll('.active');
    activeElements.forEach(element => {
      element.classList.remove('active');
    });
    event.target.classList.add('active');

    const index = event.target.dataset.index;

    this.splideSlider.go(parseInt(index));

    const visibleSlide = this.section.querySelector(`.splide__slide[data-index="${index}"]`);
    const videos = visibleSlide.querySelectorAll('.product-highlight__video');

    videos.forEach((video) => {
      if (video.className.includes('js-youtube')) {
        video.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'playVideo' }), '*');
      } else if (video.className.includes('js-vimeo')) {
        video.contentWindow.postMessage(JSON.stringify({ method: 'play'}), '*');
      } else {
        video.play();
      }
    })

    const hiddenSlides = this.section.querySelectorAll(`.splide__slide:not([data-index="${index}"])`);

    hiddenSlides.forEach((slide) => {
      const videos = slide.querySelectorAll('.product-highlight__video');

      videos.forEach((video) => {
        if (video.className.includes('js-youtube')) {
          video.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo' }), '*');
        } else if (video.className.includes('js-vimeo')) {
          video.contentWindow.postMessage(JSON.stringify({ method: 'pause'}), '*');
        } else {
          video.pause();
        }
      })
    });
  }
}